export const SUPER_USERS_MODULE_KEY = 'users';
export const SUPER_USERS_BASE_ROUTE = '/users';
export const SUPER_USERS_FILTER_KEY = 'superUsers';
